<template>
  <div :class="mergedClasses" :style="computeStyles" v-lazy="lazy">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import type { QSectionProps } from '../../composable/use-section-props'
import { useSectionMergedStyles } from '../../composable/use-section-merged-styles'
import { useSectionClasses } from '../../composable/use-section-classes'
import { useSectionImage } from '../../composable/use-section-image'
import { useSectionComputedStyles } from '../../composable/use-section-computed-styles'

const lazy = ref({
  callback: () => {},
})

// 定义组件名称
defineOptions({
  name: 'QSection',
})

// Props 定义
const props = withDefaults(defineProps<QSectionProps>(), {
  uiMeta: () => ({}),
})

// 使用 composables
const { mergedStyles, propsData } = useSectionMergedStyles(props)
const { mergedClasses } = useSectionClasses(props, propsData)
const { imageConfig } = useSectionImage(mergedStyles)
const { computeStyles } = useSectionComputedStyles(mergedStyles, imageConfig)
</script>

<style lang="scss" scoped></style>
